import type { RouteRecordRaw } from 'vue-router';
import { mdiLockOpen } from '@mdi/js';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const resetPasswordSuccessRoutes = {
  name: 'reset-password-success',
  path: 'reset-password-success',
  components: {
    default: () => import('./ResetPasswordSuccess.vue'),
    brand: () => import('./ResetPasswordSuccessBrand.vue'),
  },
  meta: {
    i18n,
    authHeader: {
      titleKey: 'resetPasswordSuccess.passwordUpdatedTitle',
      subtitleKey: 'resetPasswordSuccess.passwordUpdatedDesc',
      icon: { name: mdiLockOpen, tone: 'positive' },
      announce: 'status',
    },
  },
} satisfies RouteRecordRaw;
